/* global stripe_publishable_key */
/* global google_analytics */
/* global facebook_pixel */
/* global stripe_connect_client_id */

import React, { StrictMode } from "react";

import { createReduxEnhancer } from "@sentry/react";
import { routerMiddleware } from "connected-react-router";
import { locale } from "moment";
import { createRoot } from "react-dom/client";
import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import thunkMiddleware from "redux-thunk";

import {
  applyTheme,
  readStoredPreference,
  resolveTheme,
  ThemeProvider,
} from "@/src/contexts/ThemeContext";

import App from "./components/App";
import history from "./components/common/navigation/AppHistory";
import "./i18n";
import "./instrument";
import createRootReducer from "./reducers";
import rootSagas from "./sagas";

locale(window.navigator.language);

const sentryReduxEnhancer = createReduxEnhancer();
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers =
  process.env.NODE_ENV !== "production" &&
  typeof window === "object" &&
  // eslint-disable-next-line no-underscore-dangle
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? // eslint-disable-next-line no-underscore-dangle
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const store = createStore(
  createRootReducer(history),
  composeEnhancers(
    sentryReduxEnhancer,
    applyMiddleware(routerMiddleware(history), sagaMiddleware, thunkMiddleware),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any,
);

sagaMiddleware.run(rootSagas);

// Applique le thème persisté avant le premier paint pour éviter un flash.
applyTheme(resolveTheme(readStoredPreference()));

const container = document.getElementById("app-admin") as HTMLElement;
const root = createRoot(container);

root.render(
  <StrictMode>
    <ThemeProvider>
      <App
        facebook_pixel={facebook_pixel}
        google_analytics={google_analytics}
        history={history}
        store={store}
        stripe_connect_client_id={stripe_connect_client_id}
        stripe_publishable_key={stripe_publishable_key}
      />
    </ThemeProvider>
  </StrictMode>,
);
